import * as yup from 'yup'
import {TabOption} from '../../../../shared/components/FormTabHeader'
import {BaseEntity} from '../../../../shared/models/ApiModels'
import { IBrandModel, initialBrand } from '../brand/BrandModel'
import { initialVehicleGroup, IVehicleGroupModel } from '../vehicle-group/VehicleGroupModel'

export interface IVehicleTypeModel extends BaseEntity {
  brand: IBrandModel
  vehicleGroup: IVehicleGroupModel
  transmission: string
  name: string
  fuelType: string 
}

export const initialVehicleType: IVehicleTypeModel = {
  id: '',
  brand: initialBrand,
  vehicleGroup: initialVehicleGroup,
  transmission: '',
  name: '',
  fuelType: '', 
}

export const tabOptions: TabOption<'form' | 'list'>[] = [
  {key: 'form', title: 'Araç Tipi (Model) Tanımlama', icon: 'bi bi-geo-alt'},
  {key: 'list', title: 'Araç Tipi Listesi', icon: 'bi bi-list'},
]

export const validationvehicleType = yup.object({ 
  brandId: yup.string().trim().required('Marka seçimi zorunludur.'), 
  vehicleGroupId: yup.string().trim().required('Araç grubu zorunludur.'), 
  transmission: yup.string().trim().required('Vites türü zorunludur.'), 
  name: yup
    .string()
    .trim()
    .min(2, 'Araç tipi en az 2 karakter olmalıdır.')
    .max(50, 'Araç tipi en fazla 50 karakter olabilir.')
    .required('Araç tipi zorunludur.'), 
  fuelType: yup.string().trim().required('Yakıt türü zorunludur.'),  
})
